import ChatWindow from './ChatWindow';

export default function HeroRight({ rightVisible, startDemo }) {
  return (
    <div className={`reveal${rightVisible ? ' in' : ''}`} id="col-right">
      <ChatWindow startDemo={startDemo} />
    </div>
  );
}
